import { render, staticRenderFns } from "./card-comment.vue?vue&type=template&id=766a3833&scoped=true&"
import script from "./card-comment.vue?vue&type=script&lang=js&"
export * from "./card-comment.vue?vue&type=script&lang=js&"
import style0 from "./card-comment.vue?vue&type=style&index=0&id=766a3833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a3833",
  null
  
)

export default component.exports